document.addEventListener('DOMContentLoaded', function () {
    const variantPicker = document.querySelector('variant-picker');
    const countdownElement = document.getElementById('countdown-timer');
    const shippingDateInput = document.getElementById('shipping-date-property');
    let countdownInterval;
    let variantStatuses = [];

const style = document.createElement('style');
style.textContent = `
  .flashing-dot {
    display: inline-block;
    margin-right: 3px;
    color: blue;
    animation: flash 2s infinite;
  }

  @keyframes flash {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }

  .animated-soldout-text {
    display: inline-block;
    animation: fadeSlideIn 0.5s ease-out;
  }

  @keyframes fadeSlideIn {
    0% {
      opacity: 0;
      transform: translateY(8px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
document.head.appendChild(style);

    
    // Get the alternate message from the data attribute
    const alternateShippingMessage = countdownElement ? countdownElement.dataset.alternateMessage : '';

    function formatShippingDate(date) {
        return date.toLocaleDateString('en-US', { 
            month: 'long', 
            day: 'numeric'
        });
    }

    function toPacificTime(date) {
        return new Date(date.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
    }

    function isHoliday(date, holidays) {
        const pacificDate = toPacificTime(date);
        const dateString = pacificDate.getFullYear() + '-' + 
            String(pacificDate.getMonth() + 1).padStart(2, '0') + '-' + 
            String(pacificDate.getDate()).padStart(2, '0');
        return holidays.includes(dateString);
    }

    function getNextBusinessDay(date, holidays) {
        let nextDate = new Date(date.getTime());
        nextDate.setDate(nextDate.getDate() + 1);
        
        while (
            nextDate.getDay() === 0 || // Sunday
            nextDate.getDay() === 6 || // Saturday
            isHoliday(nextDate, holidays)
        ) {
            nextDate.setDate(nextDate.getDate() + 1);
        }
        return nextDate;
    }

    function calculateNextCutoffTime() {
        const now = toPacificTime(new Date());
        let cutoffTime = new Date(now.getTime());
        cutoffTime.setHours(shippingCutoffTime, 0, 0, 0);

        // Check if we're past today's cutoff or it's a non-shipping day
        if (now > cutoffTime || 
            now.getDay() === 0 || 
            now.getDay() === 6 || 
            isHoliday(now, shippingHolidays)) {
            // Move to next business day
            let nextDate = getNextBusinessDay(now, shippingHolidays);
            cutoffTime = new Date(nextDate.getTime());
            cutoffTime.setHours(shippingCutoffTime, 0, 0, 0);
        }

        return cutoffTime;
    }

    function getShippingDate(cutoffTime) {
        const now = toPacificTime(new Date());
        const todaysCutoff = new Date(now.getTime());
        todaysCutoff.setHours(shippingCutoffTime, 0, 0, 0);
        
        // If we're before today's cutoff and today is a valid shipping day
        if (now < todaysCutoff && 
            now.getDay() !== 0 && 
            now.getDay() !== 6 && 
            !isHoliday(now, shippingHolidays)) {
            return now;
        }
        
        // Otherwise, get next valid business day starting from tomorrow
        let nextDate = new Date(now.getTime());
        nextDate.setDate(nextDate.getDate() + 1);
        
        while (
            nextDate.getDay() === 0 || // Sunday
            nextDate.getDay() === 6 || // Saturday
            isHoliday(nextDate, shippingHolidays)
        ) {
            nextDate.setDate(nextDate.getDate() + 1);
        }
        
        return nextDate;
    }

    function toggleCountdownVisibility(show) {
        if (countdownElement) {
            countdownElement.style.display = show ? 'block' : 'none';
        }
    }

    function stopCountdown() {
        if (countdownInterval) {
            clearInterval(countdownInterval);
            countdownInterval = null;
        }
    }

    function startCountdown() {
        const cutoffTime = calculateNextCutoffTime();

        function updateCountdown() {
            const now = new Date().getTime();
            const distance = cutoffTime - now;

            if (distance > 0) {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                let countdownText = '';
                if (days > 0) {
                    countdownText += `${days}d `;
                }
                countdownText += `${hours}h ${minutes}m ${seconds}s`;

                let message = '';
                const shippingDate = getShippingDate(cutoffTime);

                // Format the shipping date
                let shippingDateFormatted;
                const today = toPacificTime(new Date());
                const tomorrow = new Date(today);
                tomorrow.setDate(tomorrow.getDate() + 1);

                const isSameDay = (date1, date2) => {
                    return date1.toDateString() === date2.toDateString();
                };
                
                const todaysCutoff = new Date(today.getTime());
                todaysCutoff.setHours(shippingCutoffTime, 0, 0, 0);
                
                if (isSameDay(shippingDate, today) && now < todaysCutoff) {
                    shippingDateFormatted = `Today, ${shippingDate.toLocaleDateString('en-US', {
                        month: 'long',
                        day: 'numeric'
                    })}`;
                } else if (isSameDay(shippingDate, tomorrow) && !isHoliday(tomorrow, shippingHolidays)) {
                    shippingDateFormatted = `Tomorrow, ${shippingDate.toLocaleDateString('en-US', {
                        month: 'long',
                        day: 'numeric'
                    })}`;
                } else {
                    shippingDateFormatted = shippingDate.toLocaleDateString('en-US', {
                        weekday: 'long',
                        month: 'long',
                        day: 'numeric'
                    });
                }

                // Construct the message
                message = `<span style="color: green;"><b>In Stock</b></span><br>Ships <strong>${shippingDateFormatted}.</strong><br>Order in the next <span style="color: green;">${countdownText}</span>`;
                
               // Add alternate shipping message if it exists
                if (alternateShippingMessage && alternateShippingMessage.trim() !== '') {
                    message += `<br><div style="background-color: #28a745; color: white; padding: 5px 5px; border-radius: 0px; line-height: 1.2; margin-top: 5px; display: inline-block;">${alternateShippingMessage}</div>`;
                }
                
                if (shippingDateInput) {
                    shippingDateInput.value = formatShippingDate(shippingDate);
                }

                countdownElement.innerHTML = message;
            } else {
                const nextDay = getNextBusinessDay(new Date(), shippingHolidays);
                countdownElement.innerHTML = "Ships same day or next business day.";
                if (shippingDateInput) {
                    shippingDateInput.value = formatShippingDate(nextDay);
                }
            }
        }

        stopCountdown();
        updateCountdown();
        countdownInterval = setInterval(updateCountdown, 1000);
    }

function loadVariantStatuses() {
    const productData = variantPicker ? variantPicker.data.product : null;

    if (!productData || !productData.variants) return;

    variantStatuses = productData.variants.map(variant => {
        const isPreOrder = variant.inventory_quantity <= 0 && variant.available === true;
        const isOutOfStock = variant.inventory_quantity <= 0 && variant.available === false;
        const shippingTimerText = document.querySelector(`[data-variant-metafield="${variant.id}"]`)?.value;
        const soldOutText = document.querySelector(`[data-variant-sold-out-text="${variant.id}"]`)?.value;

        return {
            title: variant.title,
            inventory_quantity: variant.inventory_quantity,
            isPreOrder: isPreOrder,
            isOutOfStock: isOutOfStock,
            shippingTimerText: shippingTimerText,
            soldOutText: soldOutText
        };
    });
}

function checkAndToggleCountdown() {
    if (!variantPicker) return;

    const selectedVariant = variantPicker.getSelectedOptions();
    const variant = variantStatuses.find(v =>
        v.title === selectedVariant.join(' / ')
    );

    if (!variant) return;

    stopCountdown();

    setTimeout(() => {
        const preOrderMessageElement = document.querySelector('[data-pre-order-message]');
        let preOrderMessage = preOrderMessageElement ? preOrderMessageElement.textContent : '';

        if (variant.shippingTimerText && variant.shippingTimerText.trim() !== '') {
    countdownElement.innerHTML = `<span style="color: #00008B;"><b>${variant.shippingTimerText}</b></span><br><br><br>`;
    countdownElement.style.display = 'block';
    return;
}

        if (preOrderMessage.startsWith("Preorder: ")) {
            preOrderMessage = preOrderMessage.replace("Preorder: ", "");
        }

        if (variant.isPreOrder && preOrderMessage) {
            countdownElement.innerHTML = `<span style="color: #00008B;"><b>Preorder</b></span><br>${preOrderMessage}<br>&nbsp;`;
            if (shippingDateInput) {
                const preOrderDate = new Date(preOrderMessage);
                if (!isNaN(preOrderDate.getTime())) {
                    shippingDateInput.value = formatShippingDate(preOrderDate);
                } else {
                    shippingDateInput.value = preOrderMessage;
                }
            }
            countdownElement.style.display = 'block';
        } else if (!variant.isPreOrder && variant.inventory_quantity > 0) {
            startCountdown();
            countdownElement.style.display = 'block';
        } else if (variant.isOutOfStock) {
    let soldOutMessage = `<span style="color: #D2042D;"><b>Sold Out</b></span>`;

    if (variant.soldOutText && variant.soldOutText.trim() !== '') {
        soldOutMessage += `
            <br><span class="animated-soldout-text">
              <span class="flashing-dot">●</span>
              <b>${variant.soldOutText}</b>
            </span>
            <br>Use the link below to be notified when it's back`;
    } else {
        soldOutMessage += `<br>Use the link below to be notified when it's back<br>&nbsp;`;
    }

    countdownElement.innerHTML = soldOutMessage;
    if (shippingDateInput) {
        shippingDateInput.value = '';
    }
    countdownElement.style.display = 'block';
}

else {
            countdownElement.style.display = 'none';
        }
    }, 50);
}

    if (variantPicker) {
        loadVariantStatuses();
        setTimeout(checkAndToggleCountdown, 100);

        variantPicker.addEventListener('change', () => {
            checkAndToggleCountdown();
        });
    } else {
        startCountdown();
    }
});
